<template>
    <div class="stock_warpper">
        <div class="head_warpper">
            <div class="stockA" style="display: flex; align-items: center; justify-content: space-between">
                <div class="stockB" style="display: flex; align-items: center">
                    <img
                        src="../../../../screenshots/last1.png"
                        :class="prev == null ? 'gray' : ''"
                        style="width: 30px; transform: rotate(180deg)"
                        alt=""
                        @click="isAdd == true || !isedit == true ? '' : firstPage()"
                    />
                    <img
                        src="../../../../screenshots/next1.png"
                        :class="prev == null ? 'gray' : ''"
                        style="width: 30px; transform: rotate(180deg); margin: 0 15px"
                        alt=""
                        @click="isAdd == true || !isedit == true ? '' : prevPage()"
                    />
                    <img
                        src="../../../../screenshots/next1.png"
                        :class="next == null ? 'gray' : ''"
                        style="width: 30px; margin-right: 15px"
                        alt=""
                        @click="isAdd == true || !isedit == true ? '' : nextPage()"
                    />
                    <img
                        src="../../../../screenshots/last1.png"
                        :class="next == null ? 'gray' : ''"
                        style="width: 30px"
                        alt=""
                        @click="isAdd == true || !isedit == true ? '' : lastPage()"
                    />
                    <!-- <el-button type="warning" style="margin-left: 10px" icon="el-icon-refresh" size="mini" @click="outData.isshow = true"
                        >{{ $t('common.filter') }}</el-button
                    >
                    <el-button type="success" style="margin-left: 10px" icon="el-icon-download" size="mini" @click="showOut"
                        >{{ $t('common.export') }}</el-button
                    >
                    <div style="text-align: right; margin-left: 10px">
                        <el-button type="warning" plain :disabled="isAdd || !isedit" size="mini" @click="checkData.isshow = true"
                            >批量审核</el-button
                        >
                    </div> -->
                </div>
                <div style="float: right">
                    <el-button
                        type="primary"
                        size="mini"
                        icon="el-icon-plus"
                        :disabled="isAdd || !isedit"
                        @click="add"
                        v-if="perData.allow_add == 1"
                        >{{ $t('common.add') }}</el-button
                    >
                    <el-button
                        type="warning"
                        size="mini"
                        icon="el-icon-edit"
                        :disabled="isAdd || !isedit || isCheck || nullBtn"
                        @click="handelEdit"
                        v-if="perData.allow_edit == 1"
                        >{{ $t('common.edit') }}</el-button
                    >
                    <el-button
                        type="danger"
                        size="mini"
                        icon="el-icon-delete"
                        :disabled="isAdd || !isedit || isCheck || nullBtn"
                        @click="delStock"
                        v-if="perData.allow_dele == 1"
                        >{{ $t('common.delete') }}</el-button
                    >
                    <el-button type="info" size="mini" @click="goHistory" :disabled="!isedit">{{ $t('common.historyBill') }}</el-button>
                    <el-button type="primary" size="mini" @click="exportFile" :disabled="!isedit">
                        {{ $t('common.export') }}
                    </el-button>
                    <el-button
                        type="primary"
                        v-if="perData.allow_check == 1"
                        :disabled="isAdd || !isedit || nullBtn"
                        plain
                        @click="isEdit()"
                        >{{ form.check == 1 ? $t('common.cancelAudit') : $t('common.audit') }}</el-button
                    >
                </div>
            </div>

            <div class="top_col">
                <el-row :gutter="20">
                    <el-col :span="4">
                        <div class="grid-content bg-purple">
                            {{ $t('common.creator') }}：<span>{{ form.build_name }}</span>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="grid-content bg-purple">
                            {{ $t('common.modifier') }}：<span>{{ form.modify_name }}</span>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="grid-content bg-purple">
                            {{ $t('common.createTime') }}：<span>{{ form.build_date }}</span>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="grid-content bg-purple">
                            {{ $t('common.modifyTime') }}：<span>{{ form.modify_date }}</span>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="grid-content bg-purple">
                            {{ $t('common.auditor') }}：<span>{{ form.check_name }}</span>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="grid-content bg-purple">
                            {{ $t('common.auditStatus') }}：<span :style="{ color: form.check == 1 ? '' : 'red' }">{{
                                form.check == 1 ? $t('common.audited') : $t('common.notAudited')
                            }}</span>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="top_cols">
                <el-form :model="form">
                    <el-row :gutter="20">
                        <el-col :span="6">
                            <el-form-item label="调整单号">
                                <el-input v-model="form.stockadjust_no" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="调整日期">
                                <el-date-picker
                                    type="datetime"
                                    :disabled="isedit"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="选择日期"
                                    v-model="form.stockadjust_date"
                                    style="width: 100%"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item :label="$t('common.billType') + '：'">
                                <el-select
                                    v-model="form.billtype_no"
                                    clearable
                                    default-first-option
                                    filterable
                                    placeholder="请选择"
                                    :disabled="isedit"
                                >
                                    <el-option
                                        v-for="(item, index) in allArr.billtype"
                                        :key="index"
                                        :label="item.billtype_no + ' - ' + item.billtype_name"
                                        :value="item.billtype_no.toString()"
                                        :disabled="item.status == 0"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" v-if="systemSet.isstores == 1">
                            <div class="input_col">
                                <el-form-item :label="$t('common.store') + '：'">
                                    <mySelect
                                        v-model="form.store_no"
                                        :options="allArr.store"
                                        values="store_no"
                                        labels="store_name"
                                        keys="store_no"
                                        :disable="isedit"
                                        :clearables="false"
                                    />
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="5">
                        <el-col>
                            <el-input
                                type="textarea"
                                :rows="1"
                                v-model="form.remark"
                                placeholder="请输入备注"
                                :disabled="isedit"
                            ></el-input>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <div class="table1" @mouseleave="dtlleave">
            <div class="title">
                <div style="text-align: left; color: #000; font-size: 16px; padding: 6px 0">{{ $t('common.productDetail') }}</div>
                <div>
                    <el-button type="" :disabled="isedit" @click="showImpotDialogff">{{ $t('common.import') }}</el-button>
                    <el-button type="primary" @click="dialogstock = true" :disabled="isedit">获取库存</el-button>
                </div>
            </div>

            <vxe-table
                class="stock2222"
                border
                stripe
                resizable
                keep-source
                align="center"
                ref="xTable1"
                height="440"
                show-overflow
                highlight-hover-row
                :edit-rules="validRules"
                :loading="loading"
                :footer-method="footerMethod"
                :auto-resize="true"
                show-footer
                :keyboard-config="{
                    isArrow: true,
                    isDel: true,
                    isEdit: true
                }"
                :row-class-name="rowChange"
                :data="form.dtl"
                :mouse-config="{ selected: true }"
                :edit-config="{ trigger: 'click', mode: 'row', icon: 'fa fa', activeMethod: activeRowMethod }"
                @cell-click="choseIt"
                @cell-mouseenter="dtlenter"
                :key="refushTable"
                :scroll-y="{ enabled: true, gt: 50 }"
            >
                <!-- <vxe-table-column type="checkbox" width="50"></vxe-table-column> -->
                <vxe-table-column type="seq" field="seq" width="70" title="序号">
                    <template slot="header">
                        <i class="el-icon-setting" @click.stop="isedit ? changeTable(1) : null"></i>
                    </template>
                    <template slot-scope="scoped">
                        <span class="add_" v-if="scoped.$rowIndex == dtlIndex">
                            <i class="el-icon-circle-plus-outline" @click="adddtl"></i>
                            <i class="el-icon-remove-outline" @click="deldtl(scoped)"></i>
                        </span>
                        <span v-if="scoped.$rowIndex != dtlIndex">
                            <i style="font-style: normal">{{ scoped.seq }}</i>
                        </span>
                    </template>
                </vxe-table-column>
                <template v-for="(item, index) in rkKeyList">
                    <vxe-table-column
                        :title="item.column_name"
                        :field="item.field"
                        :width="item.column_width"
                        :key="item.field + index"
                        :edit-render="{
                            name: 'input',
                            attrs: { type: item.column_type },
                            autoselect: true,
                            autofocus: '.vxe-input--inner'
                        }"
                        v-if="
                            item.column_status == 1 &&
                            item.column_type != 'select' &&
                            item.field != 'old_qty' &&
                            item.field != 'old_wgt' &&
                            item.field != 'old_trans_wgt' &&
                            item.field != 'old_goods_wgt' &&
                            item.field != 'adjust_goods_wgt' &&
                            item.field != 'adjust_trans_wgt' &&
                            item.field != 'adjust_qty' &&
                            item.field != 'adjust_wgt' &&
                            item.field != 'cost_amt'
                        "
                    >
                        <template v-slot:edit="{ row }">
                            <vxe-input
                                type="text"
                                @input="handleInput(row, item.field, item.column_type)"
                                @keydown.native="jumptable($event, row, item.field)"
                                v-model="row[item.field]"
                                @blur="item.column_type == 'number' ? $vaildator.all(row, item.tofixed, item.field) : ''"
                            ></vxe-input>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        :field="item.field"
                        :title="item.column_name"
                        v-if="
                            (item.field == 'old_goods_wgt' || item.field == 'old_trans_wgt' || item.field == 'old_qty' || item.field == 'old_wgt') && item.column_status == 1
                        "
                        :width="item.column_width"
                        :key="item.field + index"
                    >
                        <!-- <template v-slot:edit="{ row }">
                            <span>{{ row[item.field] }}</span>
                        </template> -->
                    </vxe-table-column>
                    <vxe-table-column
                        v-if="item.column_status == 1 && item.column_type == 'select'"
                        :title="item.column_name"
                        :field="item.field"
                        :width="item.column_width"
                        :key="item.field + index"
                        :edit-render="{ autofocus: '.el-input__inner' }"
                    >
                        <template #default="{ row }">
                            <span>{{
                                $selectLable.selectLable(
                                    row[item.field],
                                    allArr[item.field.replace('_no', '')],
                                    item.field,
                                    item.field.replace('_no', '_name')
                                )
                            }}</span>
                        </template>
                        <template v-slot:edit="{ row }">
                            <el-select
                                size="mini"
                                v-model="row[item.field]"
                                ref="stylefocus"
                                filterable
                                default-first-option
                                placeholder="请选择"
                                @change="changeData(row, item.field.replace('_no', ''), 'dtl')"
                                @keydown.native="jumptable($event, row, item.field)"
                            >
                                <el-option
                                    v-for="option in allArr[item.field.replace('_no', '')] || []"
                                    :key="option[item.field.replace('_no', '') + '_no']"
                                    :label="`${option[item.field.replace('_no', '') + '_no']} - ${
                                        option[item.field.replace('_no', '') + '_name']
                                    }`"
                                    :value="option[item.field.replace('_no', '') + '_no']"
                                    :disabled="option.islock == 0 ? true : false || option.status == 0"
                                ></el-option>
                            </el-select>
                        </template>
                    </vxe-table-column>
                    <!-- <vxe-table-column
                        field="old_qty"
                        v-if="item.field == 'old_qty' && item.column_status == 1"
                        :key="item.field + index"
                        title="库存数量"
                        :width="item.column_width"
                        class-name="jump"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="old_wgt"
                        v-if="item.field == 'old_wgt' && item.column_status == 1"
                        title="库存重量"
                        :width="item.column_width"
                        class-name="jump"
                        :key="item.field + index"
                    ></vxe-table-column> -->

                    <vxe-table-column
                        title="调整数量"
                        field="adjust_qty"
                        :width="item.column_width"
                        :edit-render="{}"
                        v-if="item.field == 'adjust_qty' && item.column_status == 1"
                        class-name="jump"
                        :key="item.field + index"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ countAmount(row) ? countAmount(row).toFixed(systemSet.qty) : 0 }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        title="调整重量"
                        field="adjust_wgt"
                        :width="item.column_width"
                        :edit-render="{}"
                        v-if="item.field == 'adjust_wgt' && item.column_status == 1"
                        class-name="jump"
                        :key="item.field + index"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ countWgt(row) ? countWgt(row).toFixed(systemSet.wgt) : 0 }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        title="调整成本金额"
                        field="cost_amt"
                        :width="item.column_width"
                        :edit-render="{}"
                        v-if="item.field == 'cost_amt' && item.column_status == 1"
                        class-name="jump"
                        :key="item.field + index"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ countCostAmt(row) ? countCostAmt(row).toFixed(systemSet.amt) : 0 }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        title="调整折足重"
                        field="adjust_trans_wgt"
                        :width="item.column_width"
                        :edit-render="{}"
                        v-if="item.field == 'adjust_trans_wgt' && item.column_status == 1"
                        class-name="jump"
                        :key="item.field + index"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ countTransWgt(row).toFixed(systemSet.wgt) }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        title="调整货重"
                        field="adjust_goods_wgt"
                        :width="item.column_width"
                        :edit-render="{}"
                        v-if="item.field == 'adjust_goods_wgt' && item.column_status == 1"
                        class-name="jump"
                        :key="item.field + index"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ countGoodsWgt(row).toFixed(systemSet.wgt) }}</span>
                        </template>
                    </vxe-table-column>
                </template>
                <template #empty>
                    <span style="color: red">
                        <img src="@/assets/img/dontHave.png" style="width: 200px" />
                    </span>
                </template>
            </vxe-table>
        </div>
        <div class="footer">
            <el-form :inline="true">
                <div>
                    <el-form-item label="调整数量：">
                        <p>{{ form.sumqty }}</p>
                    </el-form-item>
                    <el-form-item label="调整重量：">
                        <p>{{ form.sumwgt }}</p>
                    </el-form-item>
                </div>
            </el-form>
            <div>
                <el-button type="" size="mini" :disabled="isedit" @click="refreshData(form.stockadjust_no)" style="width: 73px"
                    >{{ $t('common.cancel') }}</el-button
                >
                <el-button type="primary" :disabled="isedit" size="mini" @click="saveItStock">{{ $t('common.save') }}</el-button>
            </div>
        </div>
        <!-- 获取库存 -->
        <el-dialog :visible.sync="dialogstock" title="获取库存" width="25%">
            <el-form>
                <el-form-item :label="$t('common.counter') ">
                    <el-select v-model="counter_no" multiple ref="stylefocus" filterable default-first-option placeholder="请选择">
                        <el-option
                            v-for="item in allArr.counter"
                            :key="item.counter_no"
                            :label="item.counter_no + ' - ' + item.counter_name"
                            :value="item.counter_no"
                            :disabled="item.islock == 0 ? true : false || item.status == 0"
                        >
                            <span style="float: left; color: #8492a6; font-size: 13px; margin-right: 10px"
                                ><el-tag style="margin-right: 10px" type="danger" v-if="item['islock'] == 1 ? true : false">锁定</el-tag
                                >{{ item.counter_no || item }}</span
                            >
                            <span style="float: right">{{ item.counter_name }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogstock = false">取 消</el-button>
                <el-button type="primary" @click="selCounter">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 放大图片 -->
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
        <!-- 筛选弹出框 -->
        <el-dialog style="padding: 0 20px" :title="$t('common.filter')" :visible.sync="outData.isshow" width="60%">
            <div class="box1">
                <el-button type="success" icon="el-icon-plus" plain circle @click="showInput"></el-button>
                <div
                    style="margin-top: 20px; display: flex; flex-wrap: wrap; align-items: center"
                    v-for="(tag, index) in bonusData.field"
                    :key="index"
                >
                    <el-select
                        filterable
                        @change="selectOne(index)"
                        clearable
                        default-first-option
                        v-model="bonusData.field[index]"
                        placeholder="请选择"
                    >
                        <el-option
                            v-for="item in allArr.screen_pull"
                            :key="item.style_no"
                            :label="item.table_name"
                            :value="item.table"
                            :disabled="item.status == 0"
                        ></el-option>
                    </el-select>
                    <span style="display: inline-block; margin: 0 10px">-</span>
                    <el-select
                        filterable
                        @change="selectOne1(index)"
                        clearable
                        default-first-option
                        v-model="bonusData.table[index]"
                        placeholder="请选择"
                    >
                        <el-option
                            v-for="item in allArr.screen_pull[arr[index] ? arr[index] : 0].field"
                            :key="item.name_no"
                            :label="item.name"
                            :value="item.name_no"
                            :disabled="item.status == 0"
                        ></el-option>
                    </el-select>
                    <span style="display: inline-block; margin: 0 10px">-</span>
                    <el-select filterable v-model="bonusData.condition[index]" clearable default-first-option placeholder="请选择">
                        <el-option
                            v-for="item in allArr.screen_condition"
                            :key="item.name_no"
                            :label="item.name"
                            :value="item.name_no"
                            :disabled="item.status == 0"
                        ></el-option>
                    </el-select>
                    <span style="display: inline-block; margin: 0 10px">-</span>
                    <el-select
                        filterable
                        v-if="allArr.screen_pull[arr[index] ? arr[index] : 0].field[arrs[index] ? arrs[index] : 0].select"
                        v-model="bonusData.parameter[index]"
                        clearable
                        default-first-option
                        placeholder="请选择"
                    >
                        <el-option
                            v-for="item in allArr.screen_pull[arr[index] ? arr[index] : 0].field[arrs[index] ? arrs[index] : 0].select"
                            :key="item.kind_no"
                            :label="item.kind_name"
                            :value="item.kind_no"
                            :disabled="item.status == 0"
                        ></el-option>
                    </el-select>
                    <el-input style="width: 20%" v-else v-model="bonusData.parameter[index]" placeholder="请输入"></el-input>
                    <el-button
                        style="margin-left: 15px"
                        type="danger"
                        icon="el-icon-minus"
                        plain
                        circle
                        @click.native.prevent="deleteRow(index, bonusData)"
                        size="small"
                    ></el-button>
                </div>
            </div>
            <el-table v-if="searchData.length" :data="searchData" style="width: 100%; margin-top: 20px">
                <el-table-column prop="index" label="调整单号">
                    <template slot-scope="scope">
                        <span>{{ scope.row }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="250" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" plain icon="el-icon-edit" @click="searchIt(scope.row)">查看详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveOk">确 定</el-button>
                <el-button @click="outData.isshow = false">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 导出弹出框 -->
        <el-dialog style="padding: 0 20px" :title="$t('common.export')" :visible.sync="excelData.isshow" width="60%">
            <div class="pro" style="text-align: center">
                <el-select
                    style="display: block; width: 50%; margin: 0 auto"
                    v-model="excelValue"
                    clearable
                    default-first-option
                    placeholder="请选择"
                >
                    <el-option label="调整" value="调整">调整</el-option>
                    <el-option label="调整明细" value="调整明细">调整明细</el-option>
                </el-select>
                <el-input style="display: block; width: 50%; margin: 10px auto" v-model="keyword" placeholder="请输入调整单号"></el-input>
                <el-select
                    style="display: block; width: 50%; margin: 0 auto 10px"
                    filterable
                    clearable
                    default-first-option
                    v-model="counter"
                    placeholder="请选择柜台"
                >
                    <el-option
                        v-for="(item, index) in allArr.counter"
                        :key="index"
                        :label="item.kind_name"
                        :value="item.kind_no"
                        :disabled="item.status == 0"
                    ></el-option>
                </el-select>
                <div style="display: block; width: 50%; margin: 0 auto 10px" v-if="excelValue == '调整'">
                    <el-date-picker
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期"
                        v-model="subscribe_date"
                        style="width: 100%"
                    ></el-date-picker>
                </div>
                <el-select
                    style="display: block; width: 50%; margin: 0 auto 10px"
                    filterable
                    clearable
                    default-first-option
                    v-model="style_no"
                    v-if="excelValue == '调整明细'"
                    placeholder="请选择产品"
                >
                    <el-option
                        v-for="(item, index) in allArr.style"
                        :key="index"
                        :label="item.style_name"
                        :value="item.style_no"
                        :disabled="item.status == 0"
                    ></el-option>
                </el-select>
                <div style="display: flex; align-items: center; margin-top: 30px; justify-content: center">
                    <el-button style="margin-left: 10px" type="success" icon="el-icon-download" @click="outExcel">{{ $t('common.export') }}</el-button>
                    <el-button type="primary" icon="el-icon-download" @click="outTem">模板导出</el-button>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="excelData.isshow = false">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 审核弹出框 -->
        <el-dialog style="padding: 0 20px" title="批量审核" :visible.sync="checkData.isshow" width="60%">
            <el-form label-width="100px">
                <el-form-item label="开始日期">
                    <el-date-picker
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期"
                        v-model="checkData.data.begin_date"
                        style="width: 100%"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期">
                    <el-date-picker
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期"
                        v-model="checkData.data.end_date"
                        style="width: 100%"
                    ></el-date-picker>
                </el-form-item>
                <div style="text-align: center">
                    <el-button type="success" @click="saveCheck('1')" style="margin-right: 30px">审 核</el-button>
                    <el-button type="warning" @click="saveCheck('0')">反审核</el-button>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="checkData.isshow = false">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 列表配置 -->
        <el-drawer title="我是标题" :visible.sync="drawers" :direction="direction" :with-header="false" destroy-on-close>
            <div class="filterKey_box">
                <div class="box_header">
                    <span>列配置</span>
                    <i class="el-icon-close icon" @click="drawers = false"></i>
                </div>
                <div class="box_content">
                    <div class="small_box">
                        <div class="text">
                            <span class="big">已显示字段</span>
                            <span class="small">拖动可调整字段顺序</span>
                        </div>
                        <ul class="ul">
                            <draggable
                                :list="keyList"
                                class="list-group"
                                ghost-class="ghost"
                                :move="checkMove"
                                animation="1000"
                                force-fallback="true"
                                chosen-class="chosen"
                            >
                                <li
                                    class="li"
                                    v-for="(item, index) in keyList"
                                    :key="index"
                                    v-show="item.column_status == 1"
                                    @mouseover="showIndex = index"
                                    @mouseleave="showIndex = null"
                                >
                                    <i class="el-icon-s-grid icon"></i>
                                    {{ item.column_name }}
                                    <i class="el-icon-error delIcon" v-show="showIndex == index" @click="liClick('del', item, index)"></i>
                                </li>
                            </draggable>
                        </ul>
                    </div>
                    <div class="small_box">
                        <div class="text">
                            <span class="big">可选字段</span>
                            <span class="small"></span>
                        </div>
                        <ul class="ul">
                            <draggable :list="keyList" :disabled="true" class="list-group" ghost-class="ghost" :move="checkMove">
                                <transition-group>
                                    <li
                                        class="li hover"
                                        v-for="(item, index) in keyList"
                                        :key="index"
                                        v-show="item.column_status == 0 && item.field_status == 1"
                                        @mouseover="optionalIndex = index"
                                        @mouseleave="optionalIndex = null"
                                        @click="liClick('add', item, index)"
                                    >
                                        <i class="el-icon-circle-plus-outline icon2" v-show="optionalIndex == index"></i>
                                        {{ item.column_name }}
                                    </li>
                                </transition-group>
                            </draggable>
                        </ul>
                    </div>
                    <div class="box_btn">
                        <el-button @click="keycancel" style="font-size: 14px">{{ $t('common.cancel') }}</el-button>
                        <el-button @click="keyConfirm" type="primary" style="font-size: 14px">{{ $t('common.confirm') }}</el-button>
                    </div>
                </div>
            </div>
        </el-drawer>
        
        <ImportDialog 
            :visible.sync="importVisible" 
            title="导入"
            upload-url="stockadjust_dtl_import"
            download-url="stockadjust_dtl_import_template"
            download-file-name="导入模板.xlsx"
            @upload-success="handleImportSuccess"
            :uploadData="uploadData"
        />
    </div>
</template>

<script>
import {
    apiFirstStock,
    apiSearchStock,
    apiLastStock,
    apiNextStock,
    apiPrevStock,
    apiAllSelectStock,
    apiModifyStock,
    apiaddStock,
    apiDelStock,
    apiGetinfo,
    apiCurrentPermisson,
    apicheckStock,
    apichooseStock,
    apiCounterStock,
    apiCounterdataStock,
    apiSystem,
    apiCounterTable,
    apiCounterAllCheck,
    setScale,
    apiGetListCorrespondingData,
    apiUpdateListCorrespondingData
} from '@/request/api';
import { translateColumns } from '@/utils/columnI18n';
import { getExportExcel } from '@/utils/multAdexportExcel.js';
export default {
    name: 'stockmanage',
    data() {
        return {
            bonusData: { field: [], table: [], condition: [], parameter: [] },
            tableIndex: 0,
            tableNo: 0,
            searchData: [],
            arr: [],
            arrs: [],
            counter: '',
            style_no: '',
            subscribe_date: '',
            tableData: [],
            allArr: '',
            form: {},
            isedit: true,
            isCheck: false,
            prev: null,
            next: null,
            dialogImageUrl: '',
            dialogVisible: false,
            outData: { isshow: false, scope: null, index: 0, data: {} },
            excelData: { isshow: false, scope: null, index: 0, data: {} },
            checkData: { isshow: false, scope: null, index: 0, data: {} },
            keyword: '',
            isAdd: false,
            loading: false,
            excelValue: '',
            imgArr: [],
            pull_counter: [],
            pull_style: [],
            usedCounter: '',
            nullBtn: false,
            systemSet: '',
            validRules: {
                style_no: [{ required: true, message: '产品编号必须填写' }],
                qty: [{ required: true, message: '实盘数量必须填写' }],
                wgt: [{ required: true, message: '实盘重量必须填写' }]
            },
            username: '',
            dtlIndex: '-1', //列表当前位置,
            dialogstock: false,
            importVisible: false,
            uploadData: {},
            isSave: true,
            counter_no: '',
            //列表擦操作字段
            keyList: [],
            drawers: false,
            direction: 'rtl',
            showIndex: null,
            optionalIndex: null,
            refushTable: true,
            rkKeyList: [],
            originalRkKeyList: [], // 保存原始的列配置（包含所有语言）
            keyStatus: '20',
            perData: {} //权限
        };
    },
    mounted() {
        // 监听语言变化
        this.$watch(
            () => this.$i18n ? this.$i18n.locale : localStorage.getItem('language'),
            (newLang) => {
                // 语言变化时，重新转换列名
                if (this.originalRkKeyList && this.originalRkKeyList.length > 0) {
                    this.rkKeyList = translateColumns(this.originalRkKeyList, newLang || 'zh-CN');
                }
            }
        );
    },
    created() {
        this.getStoneData();
        this.getPermission();
        this.getSystem();
        let bill_no = this.$route.query.bill_no;
        if (bill_no) {
            this.searchIt(bill_no);
        } else {
            this.geData();
        }

        this.getTable();
        document.addEventListener('keydown', this.mykeyup);
    },
    activated() {
        if (this.$route.query.isadd == 0) {
            this.add();
        } else {
            let bill_no = this.$route.query.bill_no;
            if (bill_no) {
                this.searchIt(bill_no);
            }
        }
    },
    watch: {
        // 'form.counter_no':function(val,oldval){
        //   if(this.allArr){
        //     this.searchCounter(val)
        //   }
        // }
    },
    methods: {
        // 显示导入弹窗
        showImpotDialogff() {
            this.uploadData.bill_date = this.form.stockadjust_date;
            this.importVisible = true;
        },
        // 导入成功回调
        handleImportSuccess(data) {
            if (data) {
                this.form.dtl = data;
            }
        },
        exportFile() {
            const loading = this.$loading({
                lock: true,
                text: '导出中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            getExportExcel('billexport_stockadjust', { stockadjust_no: this.form.stockadjust_no }, `库存调整${this.form.stockadjust_no}`)
                .then(() => {
                    loading.close();
                })
                .catch(() => {
                    loading.close();
                });
        },
        // 快捷键保存
        mykeyup(e) {
            var key = window.event.keyCode ? window.event.keyCode : window.event.which;
            if (key === 83 && e.ctrlKey) {
                // this.save('hot key');
                if (!this.isedit) {
                    if (this.$route.path == '/stockmanage') {
                        this.saveItStock();
                        e.preventDefault();
                        e.returnValue = false;
                    }
                }
            }
        },
        // 获取页面信息-----------------------------------------
        geData() {
            const loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            this.isAdd = false;
            apiLastStock({}).then((res) => {
                if (res.code == 2000) {
                    loading.close();
                    this.form = res.data.data;
                    this.next = res.data.next;
                    this.prev = res.data.prev;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    }
                    if (res.data.data.dtl[0]) {
                        var arr = [];
                        for (let i in res.data.data.dtl[0].style_img) {
                            if (res.data.data.dtl[0].style_img[i]) {
                                arr.push(res.data.data.dtl[0].style_img[i]);
                            }
                        }
                        this.imgArr = arr;
                    }
                } else {
                    loading.close();
                    if (res.data.info == '无数据请先添加' || res.data.info == '没有这条数据') {
                        this.form = { dtl: [], stock: [] };
                        this.nullBtn = true;
                    }
                    this.$message.error(res.data.info);
                    // this.$message({
                    //   offset: 100,
                    //   message: res.data.info,
                    //   type: 'error'
                    // });
                }
            });
        },
        // 获取下拉框信息---------------------------------------
        getStoneData() {
            apiAllSelectStock({}).then((res) => {
                if (res.code == 2000) {
                    this.allArr = res.data;
                    this.pull_counter = res.data.counter;
                    this.pull_style = res.data.style;
                    this.usedCounter = res.data.user_counter;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //搜索-----------------------------------------------------
        searchIt(no) {
            this.isedit = true;
            this.isAdd = false;
            apiSearchStock({
                stockadjust_no: no
            }).then((res) => {
                if (res.code == 2000) {
                    this.form = res.data.data;
                    this.next = res.data.next;
                    this.prev = res.data.prev;
                    this.outData.isshow = false;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 撤回操作--------------------------------------
        refreshData(no) {
            this.isedit = true;
            this.isAdd = false;
            if (no == null) {
                this.geData();
            } else {
                this.searchIt(no);
            }
            if (this.$route.query.isadd == 0) {
                this.$router.replace('/stockmanage');
            }
        },
        //首次进入页面 页面不可编辑状态--------------------------------
        handelEdit() {
            this.isSave = true;
            if (this.isedit == true) {
                if (this.form.check == 0) {
                    this.isedit = false;
                    if (this.form.dtl.length == 0) {
                        this.insertEvent(-1);
                    }
                } else if (this.form.check == 1) {
                    this.isCheck = true;
                }
            }
        },
        // 保存修改------------------------------------------
        saveItStock() {
            if (this.isSave) {
                this.isSave = false;
                let data = this.form;
                var table1 = this.$refs.xTable1.getTableData().fullData;
                data['dtl'] = table1;
                data['check'] = this.form.check == true ? '1' : '0';
                this.$load.show();
                if (this.isAdd == true) {
                    apiaddStock(data).then((res) => {
                        if (res.code == 2000) {
                            this.$message.success('添加成功'); //添加商品
                            this.form = res.data.data;
                            this.next = res.data.next;
                            this.prev = res.data.prev;
                            this.isAdd = false;
                            this.isedit = true;
                            if (this.$route.query.isadd == 0) {
                                this.$router.replace('/stockmanage');
                            }
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        } else {
                            this.$message.error(res.data.info);
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        }
                        this.$load.close();
                    });
                } else {
                    apiModifyStock(data).then((res) => {
                        if (res.code == 2000) {
                            this.$message.success('修改成功'); //修改商品
                            this.form = res.data.data;
                            this.next = res.data.next;
                            this.prev = res.data.prev;
                            this.isedit = true;
                            setTimeout(() => {
                                this.isSave = true;
                            }, 1500);
                        } else {
                            this.$message.error(res.data.info);
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        }
                        this.$load.close();
                    });
                }
            }
        },
        //添加产品-----------------------------------
        add() {
            if (this.isAdd == false) {
                this.isSave = true;
                this.isedit = false;
                this.form = { stockadjust_date: '', dtl: [], stock: [] };
                this.imgArr = [];
                this.form.check = false;
                this.form.remark;
                this.isAdd = true;
                this.isCheck = false;
                this.nullBtn = false;
                this.form.stockadjust_date = this.$getTime();
                const keys = Object.keys(this.allArr);
                const formKeys = keys.map((key) => `${key}_no`);
                keys.forEach((key, index) => {
                    if (Array.isArray(this.allArr[key])) {
                        // 确保 this.allArr[key] 是一个数组，而不是 undefined 或 null
                        const defaultItem = this.allArr[key].find((item) => item.isdefault == 1);
                        if (defaultItem) {
                            // 确保 defaultItem 和属性 formKeys[index] 存在
                            if (defaultItem.hasOwnProperty(formKeys[index])) {
                                this.form[formKeys[index]] = defaultItem[formKeys[index]];
                            } else {
                                console.warn(`Property ${formKeys[index]} does not exist on defaultItem`);
                                this.form[formKeys[index]] = ''; // 如果属性不存在，给它赋个默认值
                            }
                        } else {
                            // 如果没有找到 defaultItem，可能需要给 this.form[formKeys[index]] 设置一个默认值
                            console.warn(`No defaultItem found for key ${key}`);
                            this.form[formKeys[index]] = '';
                        }
                    } else {
                        // 如果 this.allArr[key] 不是一个数组，输出警告
                        console.warn(`Expected an array for key ${key}, but found ${typeof this.allArr[key]}`);
                    }
                });
                // if (this.usedCounter) {
                //     this.form.counter_no = this.usedCounter.outcounter_no;
                //     if (this.form.counter_no) {
                //         this.selCounter();
                //     }
                // }
                setTimeout(() => {
                    for (let i = 0; i < 1; i++) {
                        this.insertEvent(-1);
                    }
                }, 100);
            } else {
                this.$message.error('请先保存再添加下一个');
            }
        },
        //删除产品-----------------------------------------
        delStock() {
            this.$confirm('确定要删除该库存调整管理单吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    apiDelStock({
                        stockadjust_no: this.form.stockadjust_no
                    }).then((res) => {
                        if (res.code == 2000) {
                            this.$message({ message: '删除成功', type: 'success' });
                            if (res.data.data == null) {
                                this.form = {};
                                this.nullBtn = true;
                            } else {
                                this.form = res.data.data;
                                if (this.form.check == 1) {
                                    this.isCheck = true;
                                } else {
                                    this.isCheck = false;
                                }
                            }
                            this.next = res.data.next;
                            this.prev = res.data.prev;
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                })
                .catch(() => {});
        },
        // 获取seq---------------------------
        rowChange(row) {
            row.row.seq = row.seq;
        },
        //是否可以编辑修改(审核按钮)------------------------
        isEdit(val) {
            let check;
            if (this.form.check == 0) {
                check = 1;
            } else {
                check = 0;
            }
            apicheckStock({
                stockadjust_no: this.form.stockadjust_no,
                check: check
            }).then((res) => {
                if (res.code == 2000) {
                    if (this.form.check == 0) {
                        this.isCheck = true;
                    } else {
                        this.isedit = true;
                        this.isCheck = false;
                    }
                    this.$message.success(res.msg);
                    this.searchIt(this.form.stockadjust_no);
                } else {
                    this.$message.error(res.data.info);

                    this.searchIt(this.form.stockadjust_no);
                }
            });
        },
        // 跳到第一页-------------------------------------------
        firstPage() {
            const loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiFirstStock({}).then((res) => {
                if (res.code == 2000) {
                    loading.close();
                    this.form = res.data.data;
                    this.next = res.data.next;
                    this.prev = res.data.prev;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                } else {
                    loading.close();
                    this.$message.error(res.data.info);
                }
            });
        },
        // 跳到最后一页-------------------------------------------
        lastPage() {
            const loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiLastStock({}).then((res) => {
                if (res.code == 2000) {
                    loading.close();
                    this.form = res.data.data;
                    this.next = res.data.next;
                    this.prev = res.data.prev;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                } else {
                    loading.close();
                    this.$message.error(res.data.info);
                }
            });
        },
        // 下一页-----------------------------------------------------
        nextPage() {
            const loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiNextStock({
                stockadjust_no: this.form.stockadjust_no
            }).then((res) => {
                if (res.code == 2000) {
                    loading.close();
                    this.form = res.data.data;
                    this.next = res.data.next;
                    this.prev = res.data.prev;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                } else {
                    loading.close();
                    this.$message.error(res.data.info);
                }
            });
        },
        // 上一页------------------------------------------
        prevPage() {
            const loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiPrevStock({
                stockadjust_no: this.form.stockadjust_no
            }).then((res) => {
                if (res.code == 2000) {
                    loading.close();
                    this.form = res.data.data;
                    this.next = res.data.next;
                    this.prev = res.data.prev;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                } else {
                    loading.close();
                    this.$message.error(res.data.info);
                }
            });
        },

        //插入新数据--------------------------------------------
        async insertEvent(row) {
            let record = {
                style_no: '',
                qty: '0',
                wgt: '0',
                remark: ''
            };
            let { row: newRow } = await this.$refs.xTable1.insertAt(record, row);
            // await this.$refs.xTable1.setActiveCell(newRow, 'style_no', 'counter_no', 'qty', 'wgt');
            // this.$refs.stylefocus.focus();
        },
        //删除--------------------------------------------
        removeEvent() {
            let length = this.$refs.xTable1.getCheckboxRecords();
            if (length.length == 0) {
                this.$message.error('请选择你要删除的');
            } else {
                this.$XModal.confirm('您确定要删除该数据?').then((type) => {
                    if (type === 'confirm') {
                        this.$refs.xTable1.removeCheckboxRow();
                    }
                });
            }
        },
        //回车事件-----------------------------------------
        enterFilterEvent({ $panel, row }, event) {
            if (event.keyCode === 13) {
                //
                //
                // $panel.confirmFilter()
                this.insertEvent(-1);
            }
        },
        //放大图片---------------------------------------------
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file;
            this.dialogVisible = true;
        },
        //导出excel----------------------------------------
        showOut() {
            this.excelData.isshow = true;
            apiGetinfo({}).then((res) => {
                if (res.code == 2000) {
                    this.username = res.data.login_staff;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        outExcel() {
            var name = this.username;
            // var that=this;
            // if(name==null){
            //     this.$message.error('未登录,请重新登录');
            //     sessionStorage.removeItem('userToken');
            //     setTimeout(() => {
            //         that.$router.push('/login');
            //     }, 1000);
            // }else{
            this.excelData.isshow = false;
            this.$axios
                .get(this.$baseURL + 'stockadjust_export', {
                    params: {
                        token: sessionStorage.getItem('userToken'),
                        login_staff: name,
                        stockadjust_no: this.keyword,
                        type: this.excelValue,
                        counter_no: this.counter,
                        style_no: this.style_no,
                        stockadjust_date: this.subscribe_date
                    },
                    responseType: 'arraybuffer'
                })
                .then((response) => {
                    //创建一个blob对象,file的一种
                    let blob = new Blob([response.data], { type: 'application/x-xls' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = this.excelValue + '.xlsx';
                    link.click();
                });
            // }
        },
        //导出模板----------------------------------
        outTem() {
            this.$axios
                .get(this.$baseURL + 'stockadjust_template_export', {
                    params: {
                        token: sessionStorage.getItem('userToken'),
                        type: this.excelValue
                    },
                    responseType: 'arraybuffer'
                })
                .then((response) => {
                    //创建一个blob对象,file的一种
                    let blob = new Blob([response.data], { type: 'application/x-xls' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = this.excelValue + '模板.xlsx';
                    link.click();
                });
        },
        //页面不可编辑时提示语---------------------------
        activeRowMethod() {
            if (this.isedit == false) {
                return true;
            } else {
                this.$message.error('该状态下不可编辑');
                return false;
            }
        },
        //列配置相关接口

        changeTable(type) {
            if (type == 1) {
                this.keyList = this.rkKeyList.map((item) => item);
                this.keyStatus = '20';
            }
            this.drawers = true;
        },

        checkMove() {},

        liClick(type, item, index) {
            if (type === 'del') {
                this.$set(this.keyList[index], 'column_status', '0');
            } else if (type === 'add') {
                this.$set(this.keyList[index], 'column_status', '1');
            }
        },
        keycancel() {
            this.drawers = false;
            this.getTable();
        },
        getTable() {
            apiGetListCorrespondingData({
                id: '20'
            }).then((res) => {
                // this.rkKeyList = res.data;
                if (res.code == 2000) {
                    // 保存原始数据（包含所有语言）
                    this.originalRkKeyList = res.data;
                    // 根据当前语言转换列名
                    this.rkKeyList = translateColumns(res.data, this.$i18n ? this.$i18n.locale : 'zh-CN');
                }
            });
        },
        keyConfirm() {
            let keyList = JSON.stringify(this.keyList);
            apiUpdateListCorrespondingData({
                column: keyList,
                id: this.keyStatus
            }).then((res) => {
                this.keycancel();
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    this.refushTable = !this.refushTable;
                    console.log(this.refushTable, ' this.refushTable');
                } else if (res.code == 4000) {
                    this.$message.warning(res.data.info);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        choseIt(row) {
            var arr = [];
            for (let i in row.row.style_img) {
                if (row.row.style_img[i]) {
                    arr.push(row.row.style_img[i]);
                }
                this.imgArr = arr;
            }
        },
        changeData(row, type, e) {
            // 假设我们已经有了 type 和 row 的定义
            const selectedNo = row[`${type}_no`]; // 获取当前行的编号
            const arrayToSearch = this.allArr[type]; // 获取数据源

            if (!Array.isArray(arrayToSearch)) {
                console.error(`allArr[${type}] is not an array or is undefined`);
                return; // 如果 arrayToSearch 不是数组，直接返回
            }

            // 找到索引
            const idx = arrayToSearch.findIndex((item) => item[`${type}_no`] === selectedNo);

            if (idx !== -1) {
                // 取出相应的信息
                const info = arrayToSearch[idx];

                // 在这里，我们只更新 row[`${type}_no`] 和 row[`${type}_name`]，而不改变其他值
                row[`${type}_no`] = info[`${type}_no`]; // 更新当前行的编号
                row[`${type}_name`] = info[`${type}_name`]; // 更新当前行的名称
            } else {
                console.warn(`No entry found for selectedNo: ${selectedNo}`);
            }
            if (e == 'dtl') {
                if (row.style_no && row.counter_no) {
                    apiCounterdataStock({
                        style_no: row.style_no || '',
                        counter_no: row.counter_no || '',
                        stockadjust_date: this.form.stockadjust_date
                    }).then((res) => {
                        if (res.code == 2000) {
                            // Object.assign(row, {
                            //     old_wgt: res.data.old_wgt,
                            //     old_qty: res.data.old_qty,
                            //     qty: res.data.qty,
                            //     wgt: res.data.wgt
                            // });
                            Object.assign(row, {
                                ...res.data
                            });
                            setTimeout(() => {
                                this.$refs.xTable1.updateFooter();
                            }, 500);
                            this.$message.success(res.msg);
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                }
            }
        },
        selectName(row) {
            var newArr = this.allArr.style.filter(function (obj) {
                return obj.style_no == row.row.style_name;
            });
            var newArr1 = this.allArr.style.filter(function (obj) {
                return obj.style_no == row.row.style_name;
            });
            if (row.row.style_name) {
                row.row.style_no = newArr[0].style_no;
                this.imgArr = newArr1[0].img;
            }
        },
        //计算调整重量,数量
        countAmount(row) {
            var c = Number(row.qty || 0) - Number(row.old_qty || 0);
            row.adjust_qty = c;
            return c;
        },
        countWgt(row) {
            var b = Number(row.wgt || 0) - Number(row.old_wgt || 0);
            row.adjust_wgt = b;
            return b;
        },
        countCostAmt(row) {
            var b = Number(row.adjust_wgt || 0) * Number(row.cost_wgt_prc || 0);
            row.cost_amt = b;
            return b;
        },
        countTransWgt(row) {
            var b = Number(row.trans_wgt || 0) - Number(row.old_trans_wgt || 0);
            row.adjust_trans_wgt = b;
            return b;
        },
        countGoodsWgt(row) {
            var b = Number(row.goods_wgt || 0) - Number(row.old_goods_wgt || 0);
            row.adjust_goods_wgt = b;
            return b;
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '33'
            }).then((res) => {
                if (res.code == 2000) {
                    //
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 筛选功能--------------------------------------------------
        showInput() {
            if (this.bonusData.field == null) this.bonusData.field = [];
            if (this.bonusData.table == null) this.bonusData.table = [];
            if (this.bonusData.condition == null) this.bonusData.condition = [];
            if (this.bonusData.parameter == null) this.bonusData.parameter = [];
            let inputValue = '';
            this.bonusData.field.push(inputValue);
            this.bonusData.table.push(inputValue);
            this.bonusData.condition.push(inputValue);
            this.bonusData.parameter.push(inputValue);
        },
        selectOne(index) {
            for (var i = 0; i < this.allArr.screen_pull.length; i++) {
                if (this.allArr.screen_pull[i].table == this.bonusData.field[index]) this.tableIndex = i;
            }
            this.arr[index] = this.tableIndex;
        },
        selectOne1(index) {
            for (var j = 0; j < this.allArr.screen_pull[this.arr[index]].field.length; j++) {
                if (this.allArr.screen_pull[this.arr[index]].field[j].name_no == this.bonusData.table[index]) this.tableNo = j;
            }
            this.arrs[index] = this.tableNo;
        },
        deleteRow(index, rows) {
            for (var i = 0; i < rows.field.length; i++) {
                //
                if (rows.field[i] == this.bonusData.field[index]) {
                    rows.field.splice(i, 1);
                    rows.table.splice(i, 1);
                    rows.condition.splice(i, 1);
                    rows.parameter.splice(i, 1);
                }
            }
            // rows.splice(index, 1);
        },
        // 确认筛选-------------------------------------------------
        saveOk() {
            //
            var arrBig = [];
            for (
                var i = 0;
                i < this.bonusData.field.length &&
                this.bonusData.table.length &&
                this.bonusData.condition.length &&
                this.bonusData.parameter.length;
                i++
            ) {
                arrBig[i] = {};
                arrBig[i].table = this.bonusData.field[i];
                arrBig[i].field = this.bonusData.table[i];
                arrBig[i].condition = this.bonusData.condition[i];
                arrBig[i].parameter = this.bonusData.parameter[i];
            }
            apichooseStock({
                data: arrBig
            }).then((res) => {
                if (res.code == 2000) {
                    this.searchData = res.data;
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 自定义下拉框搜索方法
        // searchCounter(val) {
        //     // val=val.toUpperCase()
        //     this.form.counter_no = val;
        //     if (val) {
        //         var len = this.allArr.counter;
        //         var arr = [];
        //         for (var i = 0; i < len.length; i++) {
        //             if (len[i].kind_no.toLowerCase().indexOf(val.toLowerCase()) >= 0 || len[i].kind_name.indexOf(val) >= 0) {
        //                 arr.push(len[i]);
        //             }
        //         }
        //         this.pull_counter = arr;
        //     } else {
        //         this.pull_counter = this.allArr.counter;
        //     }
        // },
        refreshs() {
            this.$forceUpdate();
        },
        //获取系统设置信息
        getSystem() {
            apiSystem({}).then((res) => {
                if (res.code == 2000) {
                    this.systemSet = res.data;
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        selCounter() {
            this.$forceUpdate();
            if (this.counter_no) {
                apiCounterTable({
                    counter_no: this.counter_no.join(','),
                    stockadjust_date: this.form.stockadjust_date
                }).then((res) => {
                    if (res.code == 2000) {
                        this.form.dtl = res.data;
                        this.dialogstock = false;
                        this.$message.success(res.msg);
                        this.$forceUpdate();
                        setTimeout(() => {
                            for (let i = 0; i < this.form.dtl.length; i++) {
                                this.countAmount(this.form.dtl[i]);
                                this.countWgt(this.form.dtl[i]);
                                this.countTransWgt(this.form.dtl[i]);
                            }
                            this.$refs.xTable1.updateFooter();
                        }, 500);
                    } else {
                        this.$message.error(res.data.info);
                    }
                });
            }
        },

        //批量审核
        saveCheck(check) {
            let data = this.checkData.data;
            apiCounterAllCheck({
                begin_date: data.begin_date,
                end_date: data.end_date,
                check: check
            }).then((res) => {
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    this.searchIt(this.form.stockadjust_no);
                    this.checkData.isshow = false;
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 表尾合计---------------------------------
        footerMethod({ columns, data }) {
            return [
                columns.map((column, columnIndex) => {
                    if (columnIndex === 0) {
                        return '合计';
                    } else if (column.property == 'old_wgt') {
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.wgt)} `;
                    } else if (column.property == 'old_qty') {
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.qty)} `;
                    } else if (column.property == 'adjust_wgt') {
                        this.form.sumwgt = `${this.$utils.sum(data, column.property).toFixed(this.systemSet.wgt)} `;
                        this.$forceUpdate();
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.wgt)} `;
                    } else if (column.property == 'cost_amt') {
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.amt)} `;
                    } else if (column.property == 'adjust_qty') {
                        this.form.sumqty = `${this.$utils.sum(data, column.property).toFixed(this.systemSet.qty)} `;
                        this.$forceUpdate();
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.qty)} `;
                    } else if (column.property == 'wgt') {
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.wgt)} `;
                    } else if (column.property == 'qty') {
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.qty)} `;
                    } else {
                        return '-';
                    }
                })
            ];
        },
        // 列表出现新增
        dtlenter(row) {
            if (!this.isedit) {
                this.dtlIndex = row.$rowIndex;
            }
        },
        dtlleave() {
            this.dtlIndex = '-1';
        },

        // 新增入库明细
        adddtl() {
            this.insertEvent(-1);
        },
        deldtl(scoped) {
            let length = this.$refs.xTable1.getTableData().fullData.length;
            if (length == 1) {
                this.$message.warning('至少保留一条列表数据');
                return;
            }
            this.$refs.xTable1.remove(scoped.row);
        },
        goHistory() {
            this.$router.push({ path: '/stockHistory', query: { page: 'stockmanage' } });
        },
        //    获取重量电子秤数据
        getSetScale(row, type) {
            setScale({
                random: 'BF-202212020941'
            }).then((res) => {
                row[type] = res.data;
            });
        },
        handleInput(row, field, type) {
            if (type === 'number') {
                // 只允许数字、一个小数点和一个负号
                let inputValue = row[field]
                    .replace(/[^0-9.-]/g, '') // 删除非数字、非小数点和非负号的字符
                    .replace(/(\..*)\./g, '$1'); // 只保留第一个小数点

                // 如果输入值只有一个小数点，则替换为 '0.'
                if (inputValue === '.') {
                    inputValue = '0.';
                }
                // 处理负号，确保负号只能出现在字符串的开头
                if (inputValue && inputValue[0] === '-') {
                    // 负号在开头，允许它存在
                    inputValue = '-' + inputValue.slice(1).replace(/[^0-9.]/g, ''); // 清除负号后面的非法字符
                } else {
                    // 如果没有负号或者负号不是在开头，去掉所有负号
                    inputValue = inputValue.replace(/-/g, '');
                }

                // 更新 row[field] 的值
                row[field] = inputValue;
            }
        },
        // 尝试开发table()
        jumptable(e, row, type) {
            //所有列数据
            let column = this.$refs.xTable1.getTableColumn().tableColumn;

            // 所有行数据
            var rows = this.$refs.xTable1.getTableData().tableData;
            // 根据当前行获取行下标
            var rowIndex = this.$refs.xTable1.getVTRowIndex(row);

            // 当前列
            let nowcolumn = this.$refs.xTable1.getColumnByField(type);
            // 根据当前列获取下标
            let columnIndex = this.$refs.xTable1.getColumnIndex(nowcolumn);
            // 列数据总长度
            var length = column.length;
            if (e.keyCode == 113) {
                if (type != 'outcounter_no' && type != 'outcounter_no' && type != 'incounter_no') {
                    this.getSetScale(row, type);
                }
            }
            //问题1：回车键最后一条不需要输入的列处理
            //问题2：无法确定一个有几个需要跳过的列
            var addnum = 1; //跳过列的基本参数，每一个需要跳过的加1
            var addnumleft = 1;
            if (column[columnIndex + 1]) {
                if (column[columnIndex + 1].className == 'jump') {
                    let newColumn = column.slice(columnIndex + 1);
                    try {
                        newColumn.forEach((item) => {
                            if (item.className == 'jump') {
                                addnum += 1;
                            } else {
                                throw new Error();
                            }
                        });
                    } catch (error) {}
                }
            }
            if (column[columnIndex - 1]) {
                if (column[columnIndex - 1].className == 'jump') {
                    let newColumn = column.slice(0, columnIndex).reverse();
                    try {
                        newColumn.forEach((item) => {
                            if (item.className == 'jump') {
                                addnumleft += 1;
                            } else {
                                throw new Error();
                            }
                        });
                    } catch (error) {}
                }
            }
            // 右移;
            var jumpnum = columnIndex + addnum;
            if (column[jumpnum]) {
                var downtype = column[jumpnum].property;
            }
            // 左移
            var jumpnumleft = columnIndex - addnumleft;
            if (column[jumpnumleft]) {
                var uptype = column[jumpnumleft].property;
            }

            if (e.keyCode == '39' || e.keyCode == '13' || e.keyCode == '9') {
                if (jumpnum == length) {
                    //最后一列换行
                    if (rowIndex + 1 == rows.length) {
                        // 最后一行 先增加行在换行
                        this.adddtl();
                        rows = this.$refs.xTable1.getTableData().tableData;
                        // 换行
                        setTimeout(() => {
                            this.$refs.xTable1.setActiveRow(rows[rowIndex + 1]);
                        }, 100);
                    } else {
                        this.$refs.xTable1.setActiveRow(rows[rowIndex + 1]);
                    }
                } else {
                    // 跳转到下一列
                    this.$refs.xTable1.setActiveCell(row, downtype);
                }
            }
            if (e.keyCode == '37') {
                if (jumpnumleft == 0) {
                    //向上换行换行
                    this.$refs.xTable1.setActiveRow(rows[rowIndex - 1]);
                } else {
                    // 跳转到上一列
                    this.$refs.xTable1.setActiveCell(row, uptype);
                }
            }

            // 向下移动 (keyCode == 40)
            if (e.keyCode == '40') {
                e.preventDefault(); // 阻止默认行为
                // 确保下移时在当前列，跳到下一行的相同列
                if (rowIndex + 1 < rows.length) {
                    this.$refs.xTable1.setActiveCell(rows[rowIndex + 1], nowcolumn.property);
                }
            }

            // 向上移动 (keyCode == 38)
            if (e.keyCode == '38') {
                e.preventDefault(); // 阻止默认行为
                // 确保上移时在当前列，跳到上一行的相同列
                if (rowIndex - 1 >= 0) {
                    this.$refs.xTable1.setActiveCell(rows[rowIndex - 1], nowcolumn.property);
                }
            }
        }
    }
};
</script>
<style scoped lang="scss">
/* 修改样式 */
.stock_warpper {
    padding-bottom: 65px;
    box-sizing: border-box;
}
.head_warpper {
    box-sizing: border-box;
}
.stockB {
    padding: 0 10px;
    box-sizing: border-box;
}
</style>
<style scoped>
.avatar {
    width: 150px;
    height: 150px;
    display: block;
}
.pro .el-upload--text {
    width: auto;
    height: auto;
    border: none;
}
.modify {
    background: #eee;
    border-radius: 10px;
    padding-right: 20px;
}
.modify .el-form-item--small.el-form-item {
    margin-bottom: 0;
}
.modify .el-form-item__label {
    padding: 0 0 0 0;
}
.modify .el-input__inner {
    border: none;
    border-bottom: 1px solid #dcdfe6;
    border-radius: 0;
    color: #409eff !important;
    padding: 0 0;
}
.modify .el-input.is-disabled .el-input__inner {
    background-color: #eee;
}
.checkboxProStock {
    margin-top: 5px;
    float: right;
    margin-left: 10px;
}
.checkboxProStock input[type='checkbox'] {
    width: 17px;
    height: 17px;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    line-height: 18px;
    position: relative;
}
.checkboxProStock input[type='checkbox']::before {
    content: '';
    position: absolute;
    top: -3px;
    left: 0;
    background: #fff;
    width: 100%;
    height: 100%;
    border: 1px solid #d9d9d9;
}
.checkboxProStock input[type='checkbox']:checked::before {
    content: '\2713';
    background-color: #fff;
    position: absolute;
    top: -3px;
    left: 0;
    width: 100%;
    border: 1px solid #e50232;
    color: #e50232;
    font-size: 17px;
    font-weight: bold;
}
.vxe-table .vxe-body--row.row--stripe {
    background-color: #ecf5ff;
}
.vxe-table thead {
    background-color: #ecf5ff;
}
.vxe-table {
    background: #fff;
}
.vxe-table .vxe-body--row.row--hover,
.vxe-table .vxe-body--row.row--hover.row--stripe {
    background-color: #ecf5ff;
}
.box1 .el-select {
    width: 20%;
}
.gray {
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: gray;
}
.el-select {
    width: 100%;
}
.stock22 tr.vxe-header--row:first-child {
    background: rgb(64, 128, 128);
    color: #fff;
}
.stock2222 .vxe-body--column:not(.col--ellipsis),
.stock2222 .vxe-footer--column:not(.col--ellipsis),
.stock2222 .vxe-header--column:not(.col--ellipsis) {
    padding: 6px 0;
}
.stock22 .vxe-table.size--mini .vxe-body--column.col--ellipsis,
.stock22 .vxe-table.size--mini .vxe-footer--column.col--ellipsis,
.stock22 .vxe-table.size--mini .vxe-header--column.col--ellipsis,
.stock22 .vxe-table.vxe-editable.size--mini .vxe-body--column {
    height: 36px;
}
.stock22 .vxe-table .vxe-body--column:not(.col--ellipsis),
.stock22 .vxe-table .vxe-footer--column:not(.col--ellipsis),
.stock22 .vxe-table .vxe-header--column:not(.col--ellipsis) {
    padding: 4px 0;
}
@media screen and (max-width: 768px) {
    .vxe-table .vxe-body--column:not(.col--ellipsis),
    .vxe-table .vxe-footer--column:not(.col--ellipsis),
    .vxe-table .vxe-header--column:not(.col--ellipsis) {
        padding: 5px 0;
    }
    .stockcon {
        display: flex;
        flex-direction: column;
    }
    .stockA {
        flex-direction: column;
    }
    .stockB {
        flex-wrap: wrap;
    }
}
</style>
<style scoped lang="scss">
.footer {
    height: 56px;
    background-color: #fff;
    z-index: 999;
    padding: 10px;
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    left: 10px;
    width: 98%;
    box-shadow: 0px -2px 6px 0px #e2eeff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 40px;
    box-sizing: border-box;

    div {
        display: flex;
        p {
            width: 150px;
        }
        .buttom {
            height: 32px;
            line-height: 0;
        }

        .el-form-item {
            margin-right: 15px;
            margin-bottom: 5px;
        }
    }
}
</style>
